/* LOCALS1903 theme JS: Shopify-cart (AJAX), modals, maat-kiezer, toast, formulieren */
(function () {
  "use strict";

  /* ============ helpers ============ */
  function geld(centen) {
    return "EUR " + (centen / 100).toFixed(2).replace(".", ",");
  }

  var modalFocus = new Map();
  var focusSelector = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  function focusbare(el) { return Array.from(el.querySelectorAll(focusSelector)).filter(function (n) { return n.getClientRects().length && !n.closest('[hidden]'); }); }
  window.openModal = function (id) {
    var el = document.getElementById(id);
    if (!el) return;
    var oorsprong = document.activeElement;
    document.querySelectorAll('.modal-achter.open').forEach(function (m) {
      oorsprong = modalFocus.get(m) || oorsprong;
      m.classList.remove('open'); m.setAttribute('aria-hidden', 'true'); modalFocus.delete(m);
    });
    modalFocus.set(el, oorsprong);
    el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-hidden', 'false'); el.setAttribute('tabindex', '-1');
    var titel = el.querySelector('h1,h2,h3');
    if (titel) { if(!titel.id) titel.id = id + '-titel'; el.setAttribute('aria-labelledby', titel.id); }
    else el.setAttribute('aria-label', 'LOCALS1903 venster');
    el.classList.add('open');
    (focusbare(el)[0] || el).focus();
  };
  window.sluitModal = function (id) {
    var el = document.getElementById(id);
    if (el) {
      el.classList.remove('open'); el.setAttribute('aria-hidden', 'true');
      var terug = modalFocus.get(el); modalFocus.delete(el);
      if(terug && terug.isConnected) terug.focus();
    }
  };
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      document.querySelectorAll(".modal-achter.open").forEach(function (m) { window.sluitModal(m.id); });
    }
    if (e.key === 'Tab') {
      var modal = document.querySelector('.modal-achter.open');
      if(!modal) return;
      var velden = focusbare(modal), eerste = velden[0], laatste = velden[velden.length - 1];
      if(!eerste) { e.preventDefault(); modal.focus(); }
      else if(e.shiftKey && (document.activeElement === eerste || !modal.contains(document.activeElement))) { e.preventDefault(); laatste.focus(); }
      else if(!e.shiftKey && (document.activeElement === laatste || !modal.contains(document.activeElement))) { e.preventDefault(); eerste.focus(); }
    }
  });
  document.addEventListener("click", function (e) {
    if (e.target.classList && e.target.classList.contains("modal-achter")) {
      window.sluitModal(e.target.id);
    }
  });

  var toastTimer;
  window.toast = function (txt) {
    var t = document.getElementById("toast");
    if (!t) return;
    t.textContent = txt;
    t.classList.add("toon");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove("toon"); }, 2200);
  };

  /* ============ cart (Shopify AJAX API) ============ */
  function updateBadge(aantal) {
    var b = document.getElementById("cart-badge");
    if (!b) return;
    b.textContent = aantal;
    b.classList.toggle("toon", aantal > 0);
  }

  function haalCart() {
    return fetch("/cart.js").then(function (r) { return r.json(); });
  }

  window.addCart = function (variantId, knop) {
    if (knop) knop.disabled = true;
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || "Toevoegen mislukt"); });
        return r.json();
      })
      .then(function () {
        toast("Toegevoegd aan je mandje");
        return haalCart();
      })
      .then(function (cart) { updateBadge(cart.item_count); })
      .catch(function (err) { toast(err.message || "Er ging iets mis"); })
      .finally(function () { if (knop) knop.disabled = false; });
  };

  window.wijzigQty = function (lineKey, nieuwAantal) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: lineKey, quantity: nieuwAantal })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateBadge(cart.item_count);
        renderCartModal(cart);
        var pagina = document.getElementById("cartpage-inhoud");
        if (pagina) window.location.reload();
      });
  };

  function renderCartModal(cart) {
    var box = document.getElementById("cart-inhoud");
    if (!box) return;
    var afrekenen = document.getElementById("cart-afrekenen");
    if (!cart.items.length) {
      box.innerHTML = '<div class="cart-leeg">Je mandje is nog leeg. Scroll naar de shop en voeg iets toe.</div>';
      if (afrekenen) afrekenen.style.display = "none";
      return;
    }
    if (afrekenen) afrekenen.style.display = "";
    var html = cart.items.map(function (item) {
      var naam = item.product_title;
      var maat = item.variant_title && item.variant_title !== "Default Title" ? " (" + item.variant_title + ")" : "";
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/, "_120x$1$2") : "";
      return '<div class="cart-rij">' +
        (img ? '<img src="' + img + '" alt="">' : "") +
        '<div class="cn"><b>' + naam + maat + "</b><span>" + geld(item.price) + " per stuk</span></div>" +
        '<div class="cart-qty">' +
        '<button aria-label="Minder" onclick="wijzigQty(\'' + item.key + "'," + (item.quantity - 1) + ')">&minus;</button>' +
        "<span>" + item.quantity + "</span>" +
        '<button aria-label="Meer" onclick="wijzigQty(\'' + item.key + "'," + (item.quantity + 1) + ')">+</button>' +
        "</div>" +
        '<div class="cart-prijs">' + geld(item.final_line_price) + "</div>" +
        "</div>";
    }).join("");
    html += '<div class="cart-tot"><span>Totaal (afhalen)</span><span class="b">' + geld(cart.total_price) + "</span></div>";
    box.innerHTML = html;
  }

  window.openCart = function () {
    haalCart().then(function (cart) {
      renderCartModal(cart);
      openModal("modal-cart");
    });
  };

  window.afrekenen = function () {
    window.location.href = "/checkout";
  };

  /* ============ maat-kiezer (product met varianten) ============ */
  window.openMaatKiezer = function (knop) {
    var kaart = knop.closest("[data-product]");
    if (!kaart) return;
    var dataEl = kaart.querySelector("[data-varianten]");
    if (!dataEl) return;
    var varianten = JSON.parse(dataEl.textContent);
    if (varianten.length === 1) {
      addCart(varianten[0].id, knop);
      return;
    }
    document.getElementById("maat-titel").textContent = kaart.getAttribute("data-product");
    var grid = document.getElementById("maat-grid");
    grid.innerHTML = varianten.map(function (v) {
      var toeslag = v.prijs && v.basis && v.prijs > v.basis ? " (+" + geld(v.prijs - v.basis).replace("EUR ", "") + ")" : "";
      if (v.available) {
        return '<button class="maat-btn" onclick="kiesMaat(' + v.id + ')">' + v.titel + toeslag + "</button>";
      }
      return '<button class="maat-btn uitverkocht" disabled>' + v.titel + toeslag + "</button>";
    }).join("");
    openModal("modal-maat");
  };

  window.kiesMaat = function (variantId) {
    sluitModal("modal-maat");
    addCart(variantId, null);
  };

  /* ============ productpagina: variant-knoppen ============ */
  document.querySelectorAll("[data-variant-kiezer]").forEach(function (kiezer) {
    var input = document.getElementById("prod-variant-id");
    kiezer.querySelectorAll(".maat-btn").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (btn.classList.contains("uitverkocht")) return;
        kiezer.querySelectorAll(".maat-btn").forEach(function (b) { b.classList.remove("actief"); });
        btn.classList.add("actief");
        if (input) input.value = btn.getAttribute("data-variant-id");
        var prijsEl = document.getElementById("prod-prijs");
        var prijs = parseInt(btn.getAttribute("data-prijs"), 10);
        if (prijsEl && prijs) prijsEl.textContent = geld(prijs);
      });
    });
  });
  var prodForm = document.getElementById("prod-koop-form");
  if (prodForm) {
    prodForm.addEventListener("submit", function (e) {
      e.preventDefault();
      var input = document.getElementById("prod-variant-id");
      if (!input || !input.value) { toast("Kies eerst een maat"); return; }
      addCart(parseInt(input.value, 10), prodForm.querySelector("button[type=submit]"));
    });
  }

  /* ============ nieuws-modal ============ */
  window.openNieuws = function (kaart) {
    document.getElementById("nm-titel").textContent = kaart.getAttribute("data-titel");
    document.getElementById("nm-datum").textContent = kaart.getAttribute("data-datum");
    document.getElementById("nm-tekst").textContent = kaart.getAttribute("data-tekst");
    openModal("modal-nieuws");
  };

  /* ============ agenda: filter + inklappen ============
     Eerste 3 (gefilterde) items zichtbaar, de rest achter "Toon volledige agenda".
     Chips filteren op type (act = activiteit + alv); maandkoppen zonder zichtbare
     items verdwijnen mee. Zonder JS blijft gewoon de hele lijst staan. */
  (function () {
    var lijst = document.getElementById("ag-lijst");
    var filters = document.getElementById("ag-filters");
    var meerKnop = document.getElementById("ag-meer");
    if (!lijst || !filters || !meerKnop) return;
    var items = Array.prototype.slice.call(lijst.querySelectorAll(".ag-item"));
    if (items.length <= 3) return; // niks te verbergen
    var filter = "alles";
    var ingeklapt = true;
    var TOON = 3;

    function groep(item) {
      var t = item.getAttribute("data-type") || "";
      if (t === "thuis" || t === "uit") return t;
      return "act"; // activiteit, act en alv samen
    }

    function render() {
      var zichtbaar = 0;
      var verborgen = 0;
      items.forEach(function (item) {
        var past = filter === "alles" || groep(item) === filter;
        var toon = past && (!ingeklapt || zichtbaar < TOON);
        if (past && !toon) verborgen += 1;
        if (toon) zichtbaar += 1;
        item.style.display = toon ? "" : "none";
      });
      // maandkoppen zonder zichtbare items verbergen
      var koppen = lijst.querySelectorAll(".ag-maand");
      koppen.forEach(function (kop) {
        var el = kop.nextElementSibling;
        var heeft = false;
        while (el && !el.classList.contains("ag-maand")) {
          if (el.classList.contains("ag-item") && el.style.display !== "none") { heeft = true; break; }
          el = el.nextElementSibling;
        }
        kop.style.display = heeft ? "" : "none";
      });
      meerKnop.style.display = verborgen || !ingeklapt ? "" : "none";
      meerKnop.textContent = ingeklapt
        ? "Toon volledige agenda (nog " + verborgen + ")"
        : "Toon minder";
    }

    filters.addEventListener("click", function (e) {
      var knop = e.target.closest(".ag-fknop");
      if (!knop) return;
      filter = knop.getAttribute("data-f");
      filters.querySelectorAll(".ag-fknop").forEach(function (k) { k.classList.toggle("actief", k === knop); });
      render();
    });
    meerKnop.addEventListener("click", function () {
      ingeklapt = !ingeklapt;
      render();
      if (ingeklapt) lijst.scrollIntoView({ behavior: "smooth", block: "start" });
    });
    render();
  })();

  /* ============ uitkaarten (kopen als ingelogd lid, meteen door naar de betaling) ============
     Sinds 3 sep 2026 (Justin/Joey: "als je ingelogd bent mag hij je gelijk doorsturen naar de
     betaalpagina") is er geen tussenscherm meer. De kaarten in #uit komen uit
     GET {hub}/api/site/uitwedstrijden; GET {hub}/api/site/ik?kaart=1 zegt of de bezoeker is
     ingelogd bij Mijn LOCALS (de sessiecookie gaat mee, zelfde hoofddomein). Ingelogd: de knop
     op de kaart reserveert via POST {hub}/api/mijn/uitkaart/{id}/aanmelden en stuurt meteen door
     naar iDEAL. Niet ingelogd: de knop brengt je naar de inlogpagina van Mijn LOCALS, waar
     dezelfde wedstrijd bovenaan klaarstaat. Hub-URL en storings-mailadres staan als
     data-attributen op #uit (instelbaar in de theme-editor). */

  var UIT_MAANDEN = ["jan", "feb", "mrt", "apr", "mei", "jun", "jul", "aug", "sep", "okt", "nov", "dec"];
  var UIT_LID = null;        // { lidnummer, naam } zodra de hub de inlog bevestigt, anders null
  var UIT_LID_KLAAR = false; // false zolang de inlog-check loopt

  function uitDatum(iso) {
    var d = String(iso || "").split("-");
    if (d.length !== 3) return iso;
    return parseInt(d[2], 10) + " " + UIT_MAANDEN[parseInt(d[1], 10) - 1] + " " + d[0];
  }

  function uitkaartConfig() {
    var sec = document.getElementById("uit");
    return {
      basis: ((sec && sec.getAttribute("data-hub-url")) || "").replace(/\/+$/, ""),
      mail: (sec && sec.getAttribute("data-storing-email")) || "penningmeester@locals1903.nl"
    };
  }

  function uitStoringTekst() {
    var cfg = uitkaartConfig();
    return 'Bestellen lukt tijdelijk niet. Mail je naam, lidnummer en de wedstrijd naar <a href="mailto:' + cfg.mail + '" style="color:var(--blue)">' + cfg.mail + "</a>, dan zet het bestuur je op de lijst.";
  }

  function uitMomentTekst(iso) {
    var d = new Date(iso);
    if (isNaN(d.getTime())) return "";
    try {
      return d.toLocaleDateString("nl-NL", { timeZone: "Europe/Amsterdam", weekday: "long", day: "numeric", month: "long" }) +
        " om " + d.toLocaleTimeString("nl-NL", { timeZone: "Europe/Amsterdam", hour: "2-digit", minute: "2-digit" });
    } catch (e) {
      return d.toLocaleString("nl-NL");
    }
  }

  function uitEuro(n) {
    return "EUR " + Number(n).toFixed(2).replace(".", ",");
  }

  /* De statische blokken uit de theme-editor (laadtoestand) hebben nog een knop met
     openUitkaart(); die brengt je nu gewoon naar Mijn LOCALS. */
  window.openUitkaart = function () {
    var cfg = uitkaartConfig();
    window.location.href = (cfg.basis || "https://dashboard.locals1903.nl") + "/mijn";
  };

  /* Vraagt de hub wie er is ingelogd. Mislukt de check (hub onbereikbaar, of een andere
     site zoals de myshopify-preview waar de cookie niet meegaat), dan geldt "niet ingelogd"
     en brengt de knop je naar de inlogpagina: liever een lid dat even inlogt dan een gok. */
  function uitLidCheck() {
    var cfg = uitkaartConfig();
    if (!cfg.basis) { UIT_LID_KLAAR = true; uitVerversKnoppen(); return; }
    fetch(cfg.basis + "/api/site/ik?kaart=1", { credentials: "include", cache: "no-store" })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        UIT_LID = j && j.lid ? { lidnummer: j.lidnummer || "", naam: j.naam || "" } : null;
      })
      .catch(function () { UIT_LID = null; })
      .finally(function () { UIT_LID_KLAAR = true; uitVerversKnoppen(); });
  }

  /* Knoptekst hangt af van de inlog: tot de check klaar is "Bestel als lid", daarna
     "Log in en bestel" of "Bestel je uitkaart · EUR x". */
  function uitKnopTekst(prijs) {
    if (!UIT_LID_KLAAR) return "Bestel als lid";
    if (!UIT_LID) return "Log in en bestel";
    return "Bestel je uitkaart" + (Number(prijs) > 0 ? " · " + uitEuro(prijs) : "");
  }

  function uitVerversKnoppen() {
    document.querySelectorAll("#uit .uit-btn[data-uit-id] .uit-btn-tekst").forEach(function (el) {
      el.textContent = uitKnopTekst(el.getAttribute("data-prijs"));
    });
  }

  /* Melding op de kaart zelf (bus vol, al een kaart, storing): geen popup, gewoon boven de knop. */
  function uitKaartMelding(card, html, goed) {
    var vak = card.querySelector(".uit-melding");
    if (!vak) {
      vak = document.createElement("div");
      vak.className = "uit-melding";
      card.querySelector(".uit-foot").insertAdjacentElement("beforebegin", vak);
    }
    vak.innerHTML = html;
    vak.style.cssText = "margin:0 22px 14px;padding:12px 14px;font-size:13.5px;line-height:1.5;color:#e4e4e7;background:rgba(255,255,255,.04);border-left:4px solid " + (goed ? "#1d9e56" : "var(--blue)");
  }

  /* De bestelknop op een open kaart: ingelogd = meteen reserveren en door naar iDEAL,
     niet ingelogd = naar de inlogpagina. Zelfde hub-route als de knop in Mijn LOCALS,
     naam en lidnummer komen uit de ledenadministratie. */
  function uitKoppelKnop(knop, w, card) {
    var tekst = knop.querySelector(".uit-btn-tekst");
    knop.setAttribute("data-uit-id", w.id);
    tekst.setAttribute("data-prijs", w.prijs == null ? "" : w.prijs);
    tekst.textContent = uitKnopTekst(w.prijs);
    knop.addEventListener("click", function () {
      var cfg = uitkaartConfig();
      if (!cfg.basis) { uitKaartMelding(card, uitStoringTekst()); return; }
      if (!UIT_LID_KLAAR) return; // de check duurt een fractie van een seconde
      if (!UIT_LID) { window.location.href = cfg.basis + "/mijn"; return; }
      knop.disabled = true;
      tekst.textContent = "Naar de betaling...";
      var terug = function () { knop.disabled = false; tekst.textContent = uitKnopTekst(w.prijs); };
      fetch(cfg.basis + "/api/mijn/uitkaart/" + encodeURIComponent(w.id) + "/aanmelden", {
        method: "POST",
        credentials: "include"
      })
        .then(function (r) {
          return r.json().then(function (d) { return { status: r.status, data: d }; });
        })
        .then(function (uit) {
          if (uit.status === 200 && uit.data && uit.data.ok) {
            // De plek staat gereserveerd, iDEAL maakt hem vast. Gratis rit: meteen vast.
            if (uit.data.checkout) { window.location.href = uit.data.checkout; return; }
            uitKaartMelding(card, "<b>Je staat op de lijst!</b> Deze rit is gratis, dus je plek staat meteen vast.", true);
            knop.disabled = true;
            tekst.textContent = "Je staat op de lijst";
            return;
          }
          if (uit.status === 401) { window.location.href = cfg.basis + "/mijn"; return; } // sessie verlopen
          uitKaartMelding(card, (uit.data && uit.data.fout) || uitStoringTekst());
          terug();
        })
        .catch(function () { uitKaartMelding(card, uitStoringTekst()); terug(); });
    });
  }

  /* ============ live wedstrijdkaarten ============
     De kaarten in #uit komen uit de hub-API, zodat de sectie nooit achterloopt op het
     dashboard. De statische theme-blokken zijn alleen nog de laadtoestand; na het
     antwoord van de hub vervangen we ze. */

  function uitEsc(t) {
    var d = document.createElement("div");
    d.textContent = t == null ? "" : String(t);
    return d.innerHTML;
  }

  function uitKaartDatum(iso) {
    var dagen = ["Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za"];
    var d = new Date(String(iso) + "T12:00:00");
    if (isNaN(d.getTime())) return uitDatum(iso);
    return dagen[d.getDay()] + " " + uitDatum(iso);
  }

  /* Stand van een wedstrijd in drie smaken: open, wacht (opent later) of dicht.
     Joey (21 aug 2026): "de gesloten melding mag echt duidelijk zijn en het blok
     voor een groot deel vullen", vandaar kop + uitleg in plaats van een regeltje. */
  function uitKaartStand(w) {
    var sluit = w.sluit_op ? new Date(w.sluit_op) : null;
    var sluitTekst = sluit && !isNaN(sluit.getTime()) ? uitMomentTekst(w.sluit_op) : "";
    // Vol = vol, er is geen wachtlijst (bestuursbesluit 4 augustus 2026).
    /* "Uitverkocht" zet het bestuur ook aan als de kaarten buiten deze site om al
       verkocht zijn. Zeg dat dan ook zo (Justin, 25 aug 2026), anders blijft een lid
       wachten op plekken die nooit komen. */
    if (w.uitverkocht) {
      return { soort: "dicht", kop: "Verkoop is al geweest",
        tekst: "De kaarten voor deze wedstrijd zijn al verkocht. Er is geen wachtlijst.",
        knop: "Verkoop gesloten" };
    }
    if (w.vol) {
      return { soort: "dicht", kop: "Vol", tekst: "Alle plekken zijn vergeven. Er is geen wachtlijst.", knop: "Bus is vol" };
    }
    if (w.venster === "dicht") {
      var opent = w.opent_op ? new Date(w.opent_op) : null;
      if (opent && !isNaN(opent.getTime()) && Date.now() < opent.getTime()) {
        return {
          soort: "wacht",
          kop: "Aanmelden opent later",
          tekst: "Vanaf " + uitMomentTekst(w.opent_op) + " kun je je aanmelden" +
            (sluitTekst ? ", tot " + sluitTekst : "") + ".",
          knop: "Aanmelden opent later"
        };
      }
      /* "Sloot op ..." alleen als die datum echt voorbij is. Staat het venster dicht
         terwijl de sluitdatum nog komt (het bestuur heeft hem geforceerd dicht gezet),
         dan stond hier tot 7 sep 2026 "De inschrijving sloot woensdag 16 september",
         een datum in de toekomst. Joey zag dat om 20:00 en dacht dat het systeem
         stuk was. */
      var voorbij = sluit && !isNaN(sluit.getTime()) && Date.now() >= sluit.getTime();
      return {
        soort: "dicht",
        kop: "Aanmelden gesloten",
        tekst: voorbij
          ? "De inschrijving sloot " + sluitTekst + "."
          : "De aanmeldingen voor deze wedstrijd zijn op dit moment gesloten.",
        knop: "Aanmelden gesloten"
      };
    }
    return {
      soort: "open",
      kop: "Aanmelden is open",
      tekst: sluitTekst ? "Aanmelden kan tot " + sluitTekst + "." : "",
      knop: "Bestel als lid"
    };
  }

  function renderUitkaarten() {
    var grid = document.querySelector("#uit .uit-grid");
    var cfg = uitkaartConfig();
    if (!grid || !cfg.basis) return;
    fetch(cfg.basis + "/api/site/uitwedstrijden")
      .then(function (r) { if (!r.ok) throw new Error("status " + r.status); return r.json(); })
      .then(function (data) {
        var lijst = (data && data.wedstrijden) || [];
        grid.innerHTML = "";
        grid.removeAttribute("aria-busy");
        if (!lijst.length) {
          grid.innerHTML = '<p class="sec-desc">Er staan op dit moment geen uitwedstrijden open.</p>';
          return;
        }
        lijst.slice(0, 3).forEach(function (w) {
          var delen = String(w.titel || "").split(" - ");
          var teams = delen.length === 2
            ? uitEsc(delen[0]) + ' <span class="vs">vs</span> ' + uitEsc(delen[1])
            : uitEsc(w.titel);
          var stand = uitKaartStand(w);
          var card = document.createElement("div");
          card.className = "uit-card" + (stand.soort === "open" ? "" : " is-" + stand.soort);
          var isVol = w.uitverkocht || w.vol;
          /* Beeld, korte omschrijving en prijs komen uit de aankondiging die de hub
             zelf maakt (Joey, 19 aug 2026). Ontbreekt er iets, dan slaan we dat stukje
             over; de kaart blijft dan precies zoals hij was. */
          var promo = w.aankondiging || {};
          /* Op de site de kleinere webp-versie van hetzelfde beeld (8 okt 2026: 62 kB PNG
             naar ~15 kB); de hub maakt die zelf uit de PNG, de PNG blijft om te delen. */
          var beeldUrl = cfg.basis + promo.beeld;
          var beeldWebp = /\.png$/.test(promo.beeld) ? beeldUrl.replace(/\.png$/, ".webp") : "";
          var beeld = promo.beeld
            ? '<div class="uit-beeld"><picture>' +
              (beeldWebp ? '<source type="image/webp" srcset="' + uitEsc(beeldWebp) + '">' : "") +
              '<img src="' + uitEsc(beeldUrl) + '" alt="' +
              uitEsc(promo.titel || w.titel || "Uitwedstrijd") + '" loading="lazy"></picture></div>'
            : "";
          var eersteAlinea = String(promo.tekst || "").split("\n\n")[0];
          var info = eersteAlinea ? '<div class="uit-info">' + uitEsc(eersteAlinea) + "</div>" : "";
          /* De wedstrijdnaam en de prijs staan al op het beeld bovenaan de kaart; ze
             stonden er daaronder nog een keer (Justin, 24 aug 2026: "almere city vs
             heracles staat dubbel"). Is er geen beeld, dan valt de kop terug op tekst,
             anders zou de kaart naamloos zijn. */
          var kop = promo.beeld ? "" : '<div class="uit-teams">' + teams + "</div>";
          var bandIcoon = stand.soort === "wacht"
            ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 3"/></svg>'
            : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="5" y="11" width="14" height="9" rx="1.5"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>';
          var band = stand.soort === "open" ? "" :
            '<div class="uit-stand ' + stand.soort + '">' + bandIcoon +
              '<div><b>' + uitEsc(stand.kop) + "</b>" +
              (stand.tekst ? "<span>" + uitEsc(stand.tekst) + "</span>" : "") +
              "</div></div>";
          /* Geen exact aantal vrije plekken op de kaart: dat getal telt alleen de
             aanmeldingen die in de hub staan en klopte daardoor niet (Alexander,
             21 aug 2026). Alleen zeggen dat er plek is, zolang aanmelden open staat. */
          var venueTekst = (stand.tekst || stand.kop) +
            (stand.soort === "open" && !isVol ? " · nog plekken beschikbaar" : "");
          var venue = stand.soort === "open"
            ? '<div class="uit-venue"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 3"/></svg>' +
              uitEsc(venueTekst) + "</div>"
            : "";
          card.innerHTML = beeld +
            '<div class="uit-top"><span class="uit-tag' + (isVol ? " vol" : "") + '">' +
              (w.uitverkocht ? "Uitverkocht" : w.vol ? "Vol" : "Uitwedstrijd") +
              '</span><div class="uit-date">' + uitEsc(uitKaartDatum(w.datum)) + "</div></div>" +
            band +
            '<div class="uit-match">' + kop +
            venue + info + "</div>" +
            '<div class="uit-foot"><button class="uit-btn"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="5" y="11" width="14" height="9" rx="1.5"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg><span class="uit-btn-tekst">' +
              uitEsc(stand.knop) + "</span></button></div>";
          var knop = card.querySelector(".uit-btn");
          if (stand.soort !== "open") {
            // Geen wachtlijst en geen knop die niets doet: dicht is dicht.
            knop.disabled = true;
            knop.style.opacity = ".55";
            knop.style.cursor = "not-allowed";
          } else {
            uitKoppelKnop(knop, w, card);
          }
          grid.appendChild(card);
        });
      })
      .catch(function () {
        grid.removeAttribute("aria-busy");
        grid.innerHTML = '<p class="sec-desc">De wedstrijdlijst kan nu niet geladen worden. Probeer het later opnieuw.</p>';
      });
  }
  uitLidCheck();
  renderUitkaarten();

  /* Terug van de betaalpagina: ?kaart=gelukt|mislukt|open in de URL. De hub heeft de
     status op dat moment al bij Mollie opgehaald, dit is puur de melding. */
  (function () {
    var vak = document.getElementById("uit-status");
    if (!vak) return;
    var stand = new URLSearchParams(window.location.search).get("kaart");
    if (!stand) return;
    var tekst = {
      gelukt: "<b>Je kaart is betaald.</b> Je staat op de lijst voor de bus en je kaart wordt op naam uitgedraaid.",
      mislukt: "<b>De betaling is niet afgerond,</b> dus je plek is weer vrijgegeven. Probeer het gerust opnieuw zolang de verkoop open staat.",
      open: "<b>We wachten nog op je betaling.</b> Is die net gelukt, ververs deze pagina dan over een minuutje.",
      onbekend: "We konden deze bestelling niet terugvinden. Mail het bestuur als je twijfelt of je kaart doorkwam."
    }[stand];
    if (!tekst) return;
    vak.innerHTML = tekst;
    vak.classList.add("toon");
    var sectie = document.getElementById("uit");
    if (sectie) sectie.scrollIntoView({ behavior: "smooth", block: "start" });
  })();


  /* ============ evenementen (activiteiten met aanmelden en betalen) ============
     Zelfde opbouw als de uitkaarten hierboven, met een verschil: de knop brengt je naar
     Mijn LOCALS in plaats van meteen naar de betaling. Bij een evenement horen vragen die
     per keer verschillen (wie komt er mee, dieetwens) en dat formulier staat al in Mijn
     LOCALS; hier nog een tweede bouwen zou betekenen dat elke wijziging op twee plekken
     moet. Staat er niets open, dan verdwijnt de hele sectie van de pagina. */

  function evRender() {
    var sec = document.getElementById("evenementen");
    var grid = document.getElementById("ev-grid");
    if (!sec || !grid) return;
    var basis = (sec.getAttribute("data-hub-url") || "").replace(/\/+$/, "");
    if (!basis) return;
    fetch(basis + "/api/site/evenementen")
      .then(function (r) { if (!r.ok) throw new Error("status " + r.status); return r.json(); })
      .then(function (data) {
        var lijst = (data && data.evenementen) || [];
        evAgendaKoppelen(lijst); // ook als de sectie zelf verborgen blijft
        if (!lijst.length) { sec.style.display = "none"; return; }
        sec.style.display = "";
        grid.innerHTML = "";
        lijst.slice(0, 3).forEach(function (e) {
          var vol = e.vol;
          var dicht = !e.open;
          var soort = vol ? "vol" : dicht ? "dicht" : "open";
          var card = document.createElement("div");
          card.className = "uit-card" + (soort === "open" ? "" : " is-" + soort);

          var regels = [];
          if (e.aanvang) regels.push("Vanaf " + e.aanvang);
          regels.push(Number(e.prijs) > 0 ? uitEuro(e.prijs) + " per persoon" : "gratis");
          if (soort === "open") regels.push(e.vrij === 1 ? "nog 1 plek vrij" : "nog " + e.vrij + " plekken vrij");
          if (e.introducees_aan && soort === "open") {
            regels.push(e.max_introducees === 1 ? "je mag iemand meenemen" : "je mag maximaal " + e.max_introducees + " mensen meenemen");
          }

          var band = soort === "open" ? "" :
            '<div class="uit-stand ' + soort + '">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 3"/></svg>' +
            "<div><b>" + (vol ? "Vol" : "Aanmelden gesloten") + "</b><span>" +
            uitEsc(vol ? "Alle plekken zijn vergeven, er is geen wachtlijst." : e.sluittekst || "") +
            "</span></div></div>";

          card.innerHTML =
            '<div class="uit-top"><span class="uit-tag' + (vol ? " vol" : "") + '">' +
              (vol ? "Vol" : "Evenement") + '</span><div class="uit-date">' + uitEsc(uitKaartDatum(e.datum)) + "</div></div>" +
            band +
            '<div class="uit-match"><div class="uit-teams">' + uitEsc(e.titel) + "</div>" +
            (e.omschrijving ? '<div class="uit-info">' + uitEsc(e.omschrijving) + "</div>" : "") +
            '<div class="uit-venue">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 3"/></svg>' +
            uitEsc(regels.join(" · ")) + "</div>" +
            (soort === "open" && e.sluittekst ? '<div class="uit-info">' + uitEsc(e.sluittekst) + "</div>" : "") +
            "</div>" +
            '<div class="uit-foot"><button class="uit-btn">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="5" y="11" width="14" height="9" rx="1.5"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>' +
            "<span>" + (soort === "open" ? (UIT_LID_KLAAR && !UIT_LID ? "Log in en meld je aan" : "Meld je aan") : vol ? "Vol" : "Gesloten") +
            "</span></button></div>";

          var knop = card.querySelector(".uit-btn");
          if (soort !== "open") {
            knop.disabled = true;
            knop.style.opacity = ".55";
            knop.style.cursor = "not-allowed";
          } else {
            knop.addEventListener("click", function () { window.location.href = basis + "/mijn"; });
          }
          grid.appendChild(card);
        });
      })
      .catch(function () { sec.style.display = "none"; });
  }
  evRender();

  /* Agenda-regel klikbaar maken naar het evenement (Joey, 20 sep 2026: "kun je er voor
     zorgen dat als je op de agenda klikt, je naar het evenement gaat?"). Een activiteit
     staat twee keer op de pagina: als regel in de agenda en als kaart bij Evenementen.
     Koppelen gaat op datum plus titel, allebei als data-attribuut op de agenda-regel.
     Alleen evenementen waar je je ook echt voor kunt aanmelden worden klikbaar; een
     gewone activiteit blijft een gewone regel, anders klikt iemand naar niets. */
  function evAgendaKoppelen(lijst) {
    var regels = document.querySelectorAll("#ag-lijst .ag-item");
    if (!regels.length) return;
    var perSleutel = {};
    lijst.forEach(function (e) {
      perSleutel[e.datum + "|" + String(e.titel || "").trim().toLowerCase()] = e;
    });
    regels.forEach(function (regel) {
      var sleutel = (regel.getAttribute("data-datum") || "") + "|" +
        String(regel.getAttribute("data-titel") || "").trim().toLowerCase();
      var e = perSleutel[sleutel];
      if (!e) return;
      regel.classList.add("ag-naar-evenement");
      regel.setAttribute("role", "link");
      regel.setAttribute("tabindex", "0");
      regel.setAttribute("title", "Naar het evenement, hier kun je je aanmelden");
      // Kleine aanwijzing in de regel zelf, anders is niet te zien dat er iets te doen is.
      var wat = regel.querySelector(".ag-wat b");
      if (wat && !wat.querySelector(".ag-chip-aanmelden")) {
        var chip = document.createElement("span");
        chip.className = "ag-chip ag-chip-aanmelden";
        chip.textContent = e.vol ? "Vol" : e.open ? "Aanmelden" : "Gesloten";
        wat.appendChild(chip);
      }
      var ga = function () {
        var doel = document.getElementById("evenementen");
        if (doel) doel.scrollIntoView({ behavior: "smooth", block: "start" });
      };
      regel.addEventListener("click", ga);
      regel.addEventListener("keydown", function (ev) {
        if (ev.key === "Enter" || ev.key === " ") { ev.preventDefault(); ga(); }
      });
    });
  }

  /* Terug van de betaalpagina: ?evenement=gelukt|mislukt|open in de URL. */
  (function () {
    var vak = document.getElementById("ev-status");
    if (!vak) return;
    var stand = new URLSearchParams(window.location.search).get("evenement");
    if (!stand) return;
    var tekst = {
      gelukt: "<b>Je aanmelding is betaald.</b> Je staat op de lijst. Tot dan!",
      mislukt: "<b>De betaling is niet afgerond,</b> dus je plek is weer vrijgegeven. Probeer het gerust opnieuw zolang het aanmelden open staat.",
      open: "<b>We wachten nog op je betaling.</b> Is die net gelukt, ververs deze pagina dan over een minuutje.",
      onbekend: "We konden deze aanmelding niet terugvinden. Mail het bestuur als je twijfelt of hij doorkwam."
    }[stand];
    if (!tekst) return;
    var sectie = document.getElementById("evenementen");
    if (sectie) sectie.style.display = "";
    vak.innerHTML = tekst;
    vak.classList.add("toon");
    if (sectie) sectie.scrollIntoView({ behavior: "smooth", block: "start" });
  })();

  /* ============ lid worden (aanmelding + iDEAL via de hub) ============
     POST {hub}/api/site/lid-aanmelding -> { ok, checkout } -> doorsturen naar de
     Mollie-checkout. Terug van Mollie landt de bezoeker op /?lid-status=betaald|open|
     mislukt|onbekend#lid; het status-blok in sections/lid-worden.liquid toont dat.
     De hub-URL staat als data-hub-url op .lidform (instelbaar in de theme-editor). */

  var LID_KNOP_TEKST = "Aanmelden en betalen (EUR 25)";

  function lidwordenFout(html) {
    var vak = document.getElementById("lid-fout");
    if (!vak) return;
    if (html) { vak.innerHTML = html; vak.style.display = "block"; }
    else { vak.innerHTML = ""; vak.style.display = "none"; }
  }

  function lidwordenStoring() {
    lidwordenFout('Aanmelden lukt tijdelijk niet. Probeer het later opnieuw of mail je gegevens naar <a href="mailto:ledenadministratie@locals1903.nl" style="color:var(--blue)">ledenadministratie@locals1903.nl</a>.');
  }

  var lidFormEl = document.getElementById("LidForm");
  if (lidFormEl) {
    lidFormEl.addEventListener("submit", function (e) {
      e.preventDefault();
      if (!lidFormEl.reportValidity()) return;
      var vak = document.querySelector(".lidform");
      var basis = ((vak && vak.getAttribute("data-hub-url")) || "").replace(/\/+$/, "");
      lidwordenFout(null);
      if (!basis) { lidwordenStoring(); return; }
      var val = function (id) { var el = document.getElementById(id); return el ? (el.value || "").trim() : ""; };
      var data = {
        voorletters: val("lid-vl"), voornaam: val("lid-vn"), tussenvoegsel: val("lid-tv"),
        achternaam: val("lid-an"), geslacht: val("lid-ges"), geboortedatum: val("lid-gb"),
        adres: val("lid-adres"), postcode: val("lid-pc"), woonplaats: val("lid-wp"),
        email: val("lid-email"), telefoon: val("lid-tel"), kledingmaat: val("lid-maat"),
        relatienummer: val("lid-rel"),
        iban: val("lid-iban"), rekeninghouder: val("lid-rekeninghouder"),
        machtiging_akkoord: !!(document.getElementById("lid-machtiging") || {}).checked,
        privacy_akkoord: !!(document.getElementById("lid-privacy") || {}).checked,
        hp: val("lid-hp")
      };
      var knop = document.getElementById("lid-verstuur");
      if (knop) { knop.disabled = true; knop.textContent = "Bezig met versturen..."; }
      fetch(basis + "/api/site/lid-aanmelding", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
      })
        .then(function (r) { return r.json().then(function (d) { return { status: r.status, data: d }; }); })
        .then(function (uit) {
          if (uit.status === 200 && uit.data && uit.data.ok && uit.data.checkout) {
            if (knop) { knop.textContent = "Doorsturen naar de betaalpagina..."; }
            window.location.href = uit.data.checkout; // knop blijft uit tot de redirect
            return;
          }
          if (uit.data && uit.data.fout) lidwordenFout(uit.data.fout);
          else lidwordenStoring();
          if (knop) { knop.disabled = false; knop.textContent = LID_KNOP_TEKST; }
        })
        .catch(function () {
          lidwordenStoring();
          if (knop) { knop.disabled = false; knop.textContent = LID_KNOP_TEKST; }
        });
    });
  }

  /* Terug van de Mollie-checkout: status-parameter uit de URL tonen. */
  document.addEventListener("DOMContentLoaded", function () {
    var st = null;
    try { st = new URLSearchParams(window.location.search).get("lid-status"); } catch (e) {}
    if (!st) return;
    var blok = document.getElementById("lid-status");
    if (!blok) return;
    var teksten = {
      betaald: "<b>Welkom bij LOCALS1903!</b> Je betaling is gelukt en je aanmelding is compleet. De machtiging voor de jaarlijkse contributie is via je iDEAL-betaling vastgelegd. De ledenadministratie verwerkt je aanmelding; daarna ontvang je je lidnummer.",
      open: "<b>Je betaling wordt nog verwerkt.</b> Zodra de betaling is bevestigd, is je aanmelding compleet. Duurt het langer dan een dag? Mail dan naar ledenadministratie@locals1903.nl.",
      mislukt: "<b>Je betaling is niet gelukt of geannuleerd.</b> Je aanmelding is nog niet definitief. Vul het formulier opnieuw in om het nog een keer te proberen.",
      onbekend: "<b>We konden je aanmelding niet terugvinden.</b> Probeer het opnieuw of mail naar ledenadministratie@locals1903.nl."
    };
    blok.innerHTML = teksten[st] || teksten.onbekend;
    blok.classList.add("toon");
    if (st === "betaald" && lidFormEl) lidFormEl.style.display = "none";
    blok.scrollIntoView({ behavior: "smooth", block: "center" });
  });

  /* ============ formulier-succes na redirect ============ */
  /* Shopify herlaadt de pagina na een contact-post; secties renderen dan een
     [data-form-succes]-vlag (het contact-formulier gebruikt dit nog; lid-worden
     gaat sinds de iDEAL-flow via de hub en heeft die vlag niet meer). */
  document.addEventListener("DOMContentLoaded", function () {
    var lidOk = document.querySelector("[data-form-succes='lid']");
    if (lidOk) lidOk.scrollIntoView({ behavior: "smooth", block: "center" });
    haalCart().then(function (cart) { updateBadge(cart.item_count); });
  });

  /* ============ herroeping (wettelijk verplichte herroepingsfunctie) ============ */
  /* Modelformulier-tekst kopieren vanuit de herroep-modal. */
  window.kopieerHerroepTekst = function () {
    var bron = document.getElementById("herroep-model-tekst");
    if (!bron) return;
    var tekst = bron.textContent;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(tekst).then(function () { toast("Modelformulier gekopieerd"); });
    } else {
      var veld = document.createElement("textarea");
      veld.value = tekst;
      document.body.appendChild(veld);
      veld.select();
      try { document.execCommand("copy"); toast("Modelformulier gekopieerd"); } catch (e) {}
      document.body.removeChild(veld);
    }
  };

  /* Na een herroepings-post herlaadt Shopify de pagina met #HerroepForm in de URL;
     open dan de herroep-modal en toon de bevestiging (of de foutmelding). */
  document.addEventListener("DOMContentLoaded", function () {
    if (window.location.hash !== "#HerroepForm") return;
    var ok = document.getElementById("herroep-ok");
    if (ok) {
      ok.classList.add("toon");
      var velden = document.getElementById("herroep-velden");
      if (velden) velden.style.display = "none";
      var klaar = document.getElementById("herroep-klaar");
      if (klaar) klaar.style.display = "";
      /* Shopify markeert na een contact-post alle contactformulieren op de pagina als
         verstuurd; verberg daarom de succesmeldingen van de andere formulieren. */
      document.querySelectorAll("[data-form-succes='lid'],[data-form-succes='contact']").forEach(function (el) {
        el.classList.remove("toon");
      });
    }
    var modal = document.getElementById("modal-herroep");
    if (modal) modal.classList.add("open");
  });
})();

/* Menu op tablet en telefoon (9 okt 2026). Het menu is daar een schuifbalk zonder
   schuifbalk: op 390 px stonden 4 van de 9 links buiten beeld zonder dat je dat zag.
   Nu een vervaagde rand aan de kant waar nog meer staat (CSS: meer-links/meer-rechts)
   en staat de huidige pagina (aria-current) meteen in beeld. */
(function () {
  var nav = document.querySelector("nav.main");
  if (!nav) return;
  function rand() {
    var rest = nav.scrollWidth - nav.clientWidth;
    nav.classList.toggle("meer-links", rest > 2 && nav.scrollLeft > 2);
    nav.classList.toggle("meer-rechts", rest > 2 && nav.scrollLeft < rest - 2);
  }
  var huidig = nav.querySelector('a[aria-current="page"]');
  if (huidig && nav.scrollWidth > nav.clientWidth) {
    var links = huidig.getBoundingClientRect().left - nav.getBoundingClientRect().left + nav.scrollLeft;
    nav.scrollLeft = Math.max(0, links - (nav.clientWidth - huidig.offsetWidth) / 2);
  }
  nav.addEventListener("scroll", rand, { passive: true });
  window.addEventListener("resize", rand);
  rand();
})();

/* Live ledental (Joey, gesprek 22 okt 2026): elk [data-ledental] krijgt het aantal leden
   uit het dashboard, hetzelfde getal als de kaart Leden daar. data-ledental-min trekt er
   iets af (de vijf initialen naast de teller), data-ledental-voor zet er iets voor ("+").
   Geen antwoord = de vaste tekst uit de thema-instellingen blijft gewoon staan. */
(function () {
  var plekken = document.querySelectorAll("[data-ledental]");
  if (!plekken.length || !window.fetch) return;
  fetch("https://dashboard.locals1903.nl/api/site/leden")
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (j) {
      if (!j || !j.ok || !(j.totaal > 0)) return;
      for (var i = 0; i < plekken.length; i++) {
        var el = plekken[i];
        var n = j.totaal - (Number(el.getAttribute("data-ledental-min")) || 0);
        if (n > 0) el.textContent = (el.getAttribute("data-ledental-voor") || "") + n.toLocaleString("nl-NL");
      }
    })
    .catch(function () {});
})();
